import { useEffect } from 'react';
import { Signal } from '@easytwin/runtime';

export function useBindSignal<T extends unknown[] = []>(
  signal: Signal<T> | undefined,
  callback: (...args: T) => void,
) {
  useEffect(() => {
    signal?.on(callback);

    return () => {
      signal?.off(callback);
    };
  }, [callback, signal]);
}
